import { useEffect, useState } from 'react';

interface MidPageCTAProps {
  variant?: 'urgency' | 'social';
}

export default function MidPageCTA({ variant = 'urgency' }: MidPageCTAProps) {
  const scrollToBook = () => {
    const el = document.getElementById('book');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  if (variant === 'social') {
    return (
      <section className="py-14 bg-stone-950 relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="w-full h-full" style={{ backgroundImage: 'radial-gradient(circle at 20% 50%, #f59e0b 0%, transparent 50%), radial-gradient(circle at 80% 50%, #f59e0b 0%, transparent 50%)' }} />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <div className="flex justify-center gap-8 mb-6">
            {[
              { value: '10,000+', label: 'Creators Served' },
              { value: '4.9★', label: 'Average Rating' },
              { value: '50+', label: 'Studio Spaces' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="font-serif text-2xl md:text-3xl font-bold text-amber-400">{stat.value}</div>
                <div className="text-stone-500 text-xs mt-0.5">{stat.label}</div>
              </div>
            ))}
          </div>
          <p className="text-white font-serif text-2xl md:text-3xl font-bold mb-6">
            10,000+ creators trust us. Ready to join them?
          </p>
          <button
            onClick={scrollToBook}
            className="bg-amber-500 hover:bg-amber-600 text-white font-bold px-10 py-4 rounded-xl text-base transition-all cursor-pointer whitespace-nowrap"
          >
            Book Your Studio Now
          </button>
        </div>
      </section>
    );
  }

  return (
    <div className="bg-amber-500 py-4">
      <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <span className="relative flex h-2.5 w-2.5 flex-shrink-0">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-60" />
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-white" />
          </span>
          <span className="text-white font-semibold text-sm md:text-base whitespace-nowrap">
            Limited Availability Today — Studios Filling Fast
          </span>
        </div>
        <button
          onClick={scrollToBook}
          className="bg-white text-amber-600 font-bold text-sm px-6 py-2.5 rounded-lg hover:bg-amber-50 transition-all cursor-pointer whitespace-nowrap flex-shrink-0"
        >
          Book Your Time Slot Now &rarr;
        </button>
      </div>
    </div>
  );
}

export function UrgencyCountdown() {
  const [slots, setSlots] = useState(3);

  useEffect(() => {
    const randomSlots = Math.floor(Math.random() * 3) + 2;
    setSlots(randomSlots);
  }, []);

  const scrollToBook = () => {
    const el = document.getElementById('book');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="bg-stone-900 border-t border-b border-amber-500/30 py-3">
      <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-center gap-4 text-center">
        <div className="flex items-center gap-2">
          <i className="ri-alarm-warning-line text-amber-400 text-base" />
          <span className="text-stone-300 text-sm">
            Only <strong className="text-amber-400">{slots} studio slots</strong> remaining for this week
          </span>
        </div>
        <button
          onClick={scrollToBook}
          className="text-amber-400 hover:text-amber-300 text-sm font-semibold underline underline-offset-2 cursor-pointer whitespace-nowrap transition-colors"
        >
          Reserve your slot before it&apos;s gone
        </button>
      </div>
    </div>
  );
}
